import Reveal from '@/components/base/Reveal';
import { doc414 } from '@/mocks/strategy';

export default function Doc414() {
  return (
    <section id="doc414" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-500/20 border border-secondary-500/40">
              <i className="ri-file-text-line text-secondary-400"></i>
              <span className="text-xs md:text-sm text-secondary-300 whitespace-nowrap">
                官网最有战略价值的一句话
              </span>
            </div>
            <h2 className="mt-5 font-heading font-bold text-2xl md:text-4xl text-background-50 leading-snug">
              从「数商共同体」
              <span className="block mt-1 text-secondary-400">到「人工智能应用服务商」</span>
            </h2>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12">
            {/* 文档标注 */}
            <div className="flex justify-center">
              <div className="px-6 py-3 rounded-lg bg-secondary-500 text-background-50 font-heading font-bold text-lg md:text-xl text-center">
                {doc414.docName}
              </div>
            </div>

            <div className="flex justify-center my-4">
              <i className="ri-arrow-down-line text-secondary-400 text-xl"></i>
            </div>

            {/* 三大节点 */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {doc414.flow.map((step, i) => (
                <div key={step.label}>
                  <div className="h-full p-6 rounded-lg bg-foreground-900 border border-foreground-700 text-center">
                    <div className="w-14 h-14 mx-auto rounded-full bg-secondary-500/20 flex items-center justify-center">
                      <i className={`${step.icon} text-secondary-300 text-2xl`}></i>
                    </div>
                    <h3 className="mt-4 font-heading font-bold text-lg text-background-50">
                      {step.label}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-300 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex justify-center my-4">
              <i className="ri-arrow-down-line text-secondary-400 text-xl"></i>
            </div>

            {/* 四个方向 */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {doc414.points.map((p) => (
                <div
                  key={p}
                  className="px-4 py-3 rounded-md bg-background-50/10 border border-background-50/15 text-background-100 text-sm text-center whitespace-nowrap"
                >
                  {p}
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        {/* 产品组合 */}
        <Reveal delay={150}>
          <div className="mt-10 p-6 rounded-lg bg-foreground-900/60 border border-foreground-700">
            <div className="flex items-center gap-2">
              <i className="ri-stack-line text-accent-300"></i>
              <h3 className="font-heading font-bold text-background-50">九畴云市产品组合</h3>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              {doc414.combination.map((c) => (
                <span
                  key={c}
                  className="px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-300 text-xs whitespace-nowrap"
                >
                  {c}
                </span>
              ))}
            </div>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">{doc414.target}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}